export interface TotalsInput {
  subtotalCents: number;
  taxRatePercent: number; // 14.975 = TPS 5 % + TVQ 9.975 %
  deliveryFeeCents: number;
  tipCents: number;
}

export interface Totals {
  subtotalCents: number;
  taxCents: number;
  deliveryFeeCents: number;
  tipCents: number;
  totalCents: number;
}

/** Taxes apply on food + delivery fee; tips are never taxed. */
export function computeTotals(i: TotalsInput): Totals {
  const taxable = i.subtotalCents + i.deliveryFeeCents;
  const taxCents = Math.round((taxable * i.taxRatePercent) / 100);
  return {
    subtotalCents: i.subtotalCents,
    taxCents,
    deliveryFeeCents: i.deliveryFeeCents,
    tipCents: i.tipCents,
    totalCents: taxable + taxCents + i.tipCents,
  };
}

export function tipFromPercent(subtotalCents: number, percent: number): number {
  return Math.round((subtotalCents * percent) / 100);
}

/** `locale` is 'en-CA' or 'fr-CA' (see LOCALES). */
export function formatMoney(cents: number, currency = 'CAD', locale = 'fr-CA'): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
}
